import { __assign } from "tslib";
export var spacingGlobals = {
    xxs: 4,
    xs: 8,
    sm: 12,
    md: 16,
    lg: 20,
    xl: 24,
    xxl: 32,
    xxxl: 40,
    narrow: 10,
    wide: 18,
};
export var createSpacingAliases = function (spacing) {
    return {
        raisedSurfacePadding: spacing.md,
        cardGap: spacing.sm,
        cardPadding: spacing.xl,
    };
};
export var createSpacingGlobals = function () {
    return spacingGlobals;
};
export var createSpacing = function () {
    var aliases = createSpacingAliases(spacingGlobals);
    return __assign(__assign({}, spacingGlobals), aliases);
};
//# sourceMappingURL=spacing.js.map